export default "__VITE_ASSET__kKI$eT_N__"